var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectedTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link",
    clipPath: "url(#clip0_5419_4109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 7.5H14C13.45 7.5 13 7.95 13 8.5C13 9.05 13.45 9.5 14 9.5H17C18.65 9.5 20 10.85 20 12.5C20 14.15 18.65 15.5 17 15.5H14C13.45 15.5 13 15.95 13 16.5C13 17.05 13.45 17.5 14 17.5H17C19.76 17.5 22 15.26 22 12.5C22 9.74 19.76 7.5 17 7.5ZM8 12.5C8 13.05 8.45 13.5 9 13.5H15C15.55 13.5 16 13.05 16 12.5C16 11.95 15.55 11.5 15 11.5H9C8.45 11.5 8 11.95 8 12.5ZM10 15.5H7C5.35 15.5 4 14.15 4 12.5C4 10.85 5.35 9.5 7 9.5H10C10.55 9.5 11 9.05 11 8.5C11 7.95 10.55 7.5 10 7.5H7C4.24 7.5 2 9.74 2 12.5C2 15.26 4.24 17.5 7 17.5H10C10.55 17.5 11 17.05 11 16.5C11 15.95 10.55 15.5 10 15.5Z",
    fill: "#347AF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5419_4109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedTemplate);
export default __webpack_public_path__ + "static/media/connectedTemplate.21844f063db276f7ce96bbc4ff985230.svg";
export { ForwardRef as ReactComponent };